exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span[data-v-4505bfaf]{width:1px;background-color:#ccc;display:inline-block;height:100%}", ""]);

// exports
